/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import { Icon, IconName } from 'app/common/components/controls';
import { CloseButton } from 'app/gamma/src/components/buttons';
import buttonStyles from 'app/gamma/src/components/shared/button.less';
import { closePopover, PopoverName, State } from 'app/gamma/src/modules';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { PopoverTestIds } from '@trello/webdriverio-tests';
import styles from './popover-header.less';

interface DispatchProps {
  onClose: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

interface PopoverHeaderProps {
  popoverName: PopoverName;
  onClickBack?:
    | (() => void)
    | React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
  showCloseButton?: boolean;
  title?: React.ReactNode;
  onCloseButtonClick?: () => void;
}

export class PopoverHeaderUnconnected extends React.Component<
  DispatchProps & PopoverHeaderProps
> {
  render() {
    const { onClose, onClickBack, showCloseButton, title } = this.props;

    return (
      <div className={styles.header}>
        {onClickBack ? (
          <button
            className={classNames(buttonStyles.buttonLink, styles.headerBack)}
            onClick={onClickBack}
          >
            <Icon name={IconName.Back} small quiet />
          </button>
        ) : null}

        {title && (
          <span className={styles.headerTitle}>
            {React.Children.map(title, (child) => <>{child}</>)}
          </span>
        )}

        {(title || showCloseButton) && (
          <CloseButton
            className={styles.headerClose}
            onClick={onClose}
            testId={PopoverTestIds.ClosePopover}
            small
            quiet
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<State>,
  ownProps: PopoverHeaderProps,
) => {
  return {
    onClose(e: React.MouseEvent<HTMLElement>) {
      // This is here to prevent any parent popovers
      // from closing in the case of a nested popover
      e.preventDefault();
      e.stopPropagation();
      if (ownProps.onCloseButtonClick) {
        ownProps.onCloseButtonClick();
      }
      dispatch(closePopover(ownProps.popoverName));
    },
  };
};

export default connect(
  undefined,
  mapDispatchToProps,
)(PopoverHeaderUnconnected);
